import { render, staticRenderFns } from "./MyPatient.vue?vue&type=template&id=ba57367a&scoped=true"
import script from "./MyPatient.vue?vue&type=script&lang=js"
export * from "./MyPatient.vue?vue&type=script&lang=js"
import style0 from "./MyPatient.vue?vue&type=style&index=0&id=ba57367a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba57367a",
  null
  
)

export default component.exports